const pendingResumeNavigation = {
    PHOTO_RETAKE: 'PHOTO_RETAKE',
};

export default pendingResumeNavigation;
